module.exports = __webpack_public_path__ + "img/subaccounts.63774a03.svg";